'use client'

import type { ReactNode } from 'react'
import { SharedSurfaceProvider, type SharedSurface } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'
import { MsgDeskLoading } from '@/mailboxDesk/MsgDeskLoading'
import { sharedSkin } from './SharedSkin'

// Mailbox wiring for the Shared-area skeleton: mailbox supplies its loading widget
// (Layer C look component) and its skin through the seam.

const mailboxSharedSurface: SharedSurface = {
  Loading: MsgDeskLoading,
  skin: sharedSkin,
}

export function MailboxSharedSurfaceProvider({ children }: { children: ReactNode }) {
  return <SharedSurfaceProvider value={mailboxSharedSurface}>{children}</SharedSurfaceProvider>
}
